export default "__VITE_ASSET__CxOUkQk3__"